export const CLASS_NAMES = {
  Customer: "Customer",
  Referral: "Referral",
  Review: "Review",
  User: "User",
  SpiffPhoto: "SpiffPhoto",
  ServiceTitanInvoiceItem: "ServiceTitanInvoiceItem",
  SpiffTriggerPlaceholder: "SpiffTriggerPlaceholder",
} as const;

export type ClassName = (typeof CLASS_NAMES)[keyof typeof CLASS_NAMES];
